import { ArrowLeft, KeyRound, Search } from 'lucide-react'
import { cn } from '../../lib/utils'

interface SecretToolbarProps {
  environment: string
  path: string
  search: string
  total: number
  isDark: boolean
  onBack: () => void
  onEnvironmentChange: (value: string) => void
  onPathChange: (value: string) => void
  onSearchChange: (value: string) => void
}

function inputClass(isDark: boolean) {
  return cn(
    'h-9 rounded-md border px-3 text-base outline-none md:text-sm',
    isDark ? 'border-white/[0.08] bg-surface-2 text-neutral-100' : 'border-neutral-200 bg-white text-neutral-900',
  )
}

export function SecretToolbar({
  environment,
  path,
  search,
  total,
  isDark,
  onBack,
  onEnvironmentChange,
  onPathChange,
  onSearchChange,
}: SecretToolbarProps) {
  return (
    <div className={cn('flex flex-wrap items-center gap-3 border-b px-4 py-3', isDark ? 'border-white/[0.06] bg-surface-1' : 'border-neutral-200 bg-white')}>
      <button type="button" onClick={onBack} className="rounded-md p-1" title="Go back" aria-label="Go back">
        <ArrowLeft className="h-4 w-4" />
      </button>
      <KeyRound className={cn('h-4 w-4', isDark ? 'text-brand-400' : 'text-brand-600')} />
      <h1 className="text-sm font-semibold">Secrets</h1>
      <span className={cn('text-xs', isDark ? 'text-neutral-500' : 'text-neutral-400')}>
        {total} {total === 1 ? 'entry' : 'entries'}
      </span>
      <div className="min-w-4 flex-1" />
      <input className={cn(inputClass(isDark), 'w-28')} value={environment} onChange={(e) => onEnvironmentChange(e.target.value)} aria-label="Environment" />
      <input className={cn(inputClass(isDark), 'w-32')} value={path} onChange={(e) => onPathChange(e.target.value)} aria-label="Path" />
      <div className="relative min-w-[180px] flex-1 sm:flex-none">
        <Search className="absolute left-2.5 top-1/2 h-3.5 w-3.5 -translate-y-1/2 text-neutral-400" />
        <input className={cn(inputClass(isDark), 'w-full pl-8 sm:w-56')} value={search} onChange={(e) => onSearchChange(e.target.value)} placeholder="Search keys" />
      </div>
    </div>
  )
}
